import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getFormattedPolicyNumber } from '@utils/policy';
import { CustomerNamedInsuredUpdateRequestResult } from '@lio/api-types';
import { customerQueryKey } from './keys';

export type CustomerNamedInsuredUpdateRequest = CustomerNamedInsuredUpdateRequestResult;
export type NamedInsuredEndorsementTransaction =
  CustomerNamedInsuredUpdateRequestResult['endorsementTransactions'][number];
export type NamedInsuredFailedPolicy = NonNullable<CustomerNamedInsuredUpdateRequestResult['failedPolicies']>[number];

export const formatNamedInsuredPolicyNumber = (tx: NamedInsuredEndorsementTransaction): string =>
  tx.policy.policyNumber
    ? getFormattedPolicyNumber(tx.policy.policyNumberPrefix, tx.policy.policyNumber.policyNumber)
    : tx.policy.policyNumberPrefix;

export const useGetNamedInsuredUpdateRequest = (customerId: string, policyId?: string) => {
  const client = useClient();
  const result = useQuery<CustomerNamedInsuredUpdateRequest | null>({
    queryKey: customerQueryKey.getNamedInsuredUpdateRequest(customerId, policyId),
    queryFn: async () => {
      const query = policyId ? `?policyId=${policyId}` : '';
      return client
        .get(`customer/${customerId}/named-insured-update-request${query}`)
        .json<CustomerNamedInsuredUpdateRequest | null>();
    },
    enabled: !!customerId,
    refetchOnWindowFocus: false,
  });
  return { ...result, updateRequest: result.data ?? null };
};
